var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_286_499)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4062 6.25H2.34375C1.05141 6.25 0 7.30141 0 8.59375V17.6562C0 18.9486 1.05141 20 2.34375 20H11.4062C12.6986 20 13.75 18.9486 13.75 17.6562V8.59375C13.75 7.30141 12.6986 6.25 11.4062 6.25ZM12.1875 17.6562C12.1875 18.087 11.837 18.4375 11.4062 18.4375H2.34375C1.91297 18.4375 1.5625 18.087 1.5625 17.6562V8.59375C1.5625 8.16297 1.91297 7.8125 2.34375 7.8125H11.4062C11.837 7.8125 12.1875 8.16297 12.1875 8.59375V17.6562ZM7.65625 10.7812H6.09375V12.3438H4.53125V13.9062H6.09375V15.4688H7.65625V13.9062H9.21875V12.3438H7.65625V10.7812ZM14.5312 3.125H3.125V4.6875H14.5312C14.962 4.6875 15.3125 5.03797 15.3125 5.46875V16.875H16.875V5.46875C16.875 4.17641 15.8236 3.125 14.5312 3.125ZM17.6562 0H6.25V1.5625H17.6562C18.087 1.5625 18.4375 1.91297 18.4375 2.34375V13.75H20V2.34375C20 1.05141 18.9486 0 17.6562 0Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_286_499"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.16fe715c050415a2acf719edcfa4d672.svg";
export { ForwardRef as ReactComponent };